import * as go from 'gojs';
import * as _ from 'lodash/fp';
import { iteratorToArray } from '../iterator-to-array';
import { findExtremeZOrders, getFrontLayer, setOrderingProps } from './utils';

const assignZOrderToGroupHierarchy = (
  root: go.Part,
  zOrder: number,
  layerName: string,
  zOrderProp?: string,
  layerProp?: string,
) => {
  const stack = [{ part: root, zOrder }];
  while (stack.length) {
    const { part, zOrder } = stack.pop()!;
    setOrderingProps(part, zOrder, layerName, zOrderProp, layerProp);
    if (part instanceof go.Group) {
      stack.push(...getMemberParts(part, isNaN(zOrder) ? NaN : zOrder + 1));
    }
  }
};

const getMemberParts = (group: go.Group, zOrder: number) =>
  _.flowRight(
    _.map((part: go.Part) => ({ part, zOrder })),
    iteratorToArray,
  )(group.memberParts);

export const bringToFront = (part: go.Part, zOrderProp?: string, layerProp?: string) => {
  if (!part) {
    return;
  }

  if (part instanceof go.Group) {
    part.memberParts.each((p) => bringToFront(p, zOrderProp, layerProp));
  }

  if (part.diagram) {
    const topLayer = getFrontLayer(part.diagram);
    part.diagram.commit(() => {
      const { highestZOrder } = findExtremeZOrders(topLayer!);
      assignZOrderToGroupHierarchy(part, highestZOrder + 1, topLayer!.name, zOrderProp, layerProp);
    });
  }
};
